import React from "react";

interface EducationModalProps {
  close: any;
}

const EducationModal: React.FC<EducationModalProps> = ({ close }) => {
  return (
    <div className="work-item">
      <div className="portfolio-modal-dialog bg-white">
        <a
          className="close-button d-none d-md-block portfolio-modal-dismiss"
          href="#education"
          onClick={close}
        >
          <i className="fa fa-3x fa-times"></i>
        </a>
        <div className="container text-center">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <h2 className="text-secondary text-uppercase mb-0">
                Technical University Of Kenya
              </h2>
              <hr className="star-dark mb-5" />
              <p className="mb-5">
                <h2> Computer Programming </h2>I gained lots of handson skills
                in programming with introductory languages like C,C++ and Java.
                Studied DBMS Systems and Interacted with advanced Database
                System like Oracle ,Postgre and MYSQL
                <h2> Computer Ethics and Organization Management</h2>
                Studied computer ethics and computer based legal alignments.
              </p>
              <a
                className="btn btn-primary btn-lg rounded-pill portfolio-modal-dismiss"
                href="#education"
                onClick={close}
              >
                <i className="fa fa-close"></i>
                Close Education
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EducationModal;
